import { gql } from '@apollo/client';

export default gql`
  mutation CreateFolderMutation($folder: FolderInput!) {
    createFolder(input: { folder: $folder }) {
      folder {
        id
      }
    }
  }
`;
